import React, { useState, useEffect } from 'react'
import Navbar from '../../../ReusableBlocks/Navbar';
import Footer from '../../../ReusableBlocks/FooterBlock';
import { Link, useLocation } from "react-router-dom";
// import contents from '../ContentStore/ContentStoreData'
import Modal from 'react-bootstrap/Modal';

import 'react-toastify/dist/ReactToastify.css';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Swal from 'sweetalert2';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { fetchContent } from '../../../Redux/Dashboard/External/ContentStore/ContentStoreAction';
import { contentSearch } from '../../../Redux/Dashboard/External/Search/ContentSearchAction'
import ReactPlayer from 'react-player';
import LoadingScreen from '../../../ReusableBlocks/LoadingScreen';
import * as PATH from '../../../CentralisedLink'
import { getContentStoreCardBackgroundStyle, getMediaProvider, normalizeMediaUrl } from '../../../Utils/mediaUrls';



// Loading Spinner Component
const LoadingSpinner = () => (
    <div className="spinner">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
    </div>
);

const isVideoContent = (file) => ['Video', 'Demo Shorts', 'Shorts'].includes(file?.contentType);

const getReleaseNoteKey = (file) => `${file.fileName}-${file.releaseDate}`;





const Content_Store_v2 = (props) => {

    // Inside the Content_Store_v2 component
    const keywords = ["Service", "Dashboard", "Ops", "Helix"];
    const { enqueueSnackbar } = useSnackbar();

    // File Viewer Popup
    const [playerHeight, setPlayerHeight] = React.useState('400px');
    const [showFileModal, setFileModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [downloading, setDownloading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [hasSearched, setHasSearched] = useState(false);
    const [showSearchResultsModal, setShowSearchResultsModal] = useState(false);
    const [waitingMessage, setWaitingMessage] = useState('');
    const [playing, setPlaying] = useState(false);
    const [showAll, setShowAll] = useState(false);


    const handlePlayButtonClick = () => {
        setPlaying(true);
    };

    const dispatch = useDispatch();
    const location = useLocation();


    const { content } = useSelector(state => state.Content);
    const isLoading = useSelector(state => state.Content?.loading);
    const errorMessage = useSelector(state => state.Content?.error);


    const { results } = useSelector(state => state.ContentSearch);
    const isLoadingSer = useSelector(state => state.ContentSearch?.loading);
    const errorMessageser = useSelector(state => state.ContentSearch?.error);


    useEffect(() => {
        const updatePlayerHeight = () => {
            const width = window.innerWidth;
            if (width >= 1200) setPlayerHeight('400px');
            else if (width >= 768) setPlayerHeight('400px');
            else if (width >= 430) setPlayerHeight("200px");
            else setPlayerHeight('400px');
        };

        updatePlayerHeight(); // Set initial height
        window.addEventListener('resize', updatePlayerHeight);

        return () => window.removeEventListener('resize', updatePlayerHeight);
    }, []);



    useEffect(() => {
        dispatch(fetchContent());
    }, [dispatch]);


    useEffect(() => {
        console.log(results?.result)
        if (results?.result?.length > 0) {
            setSearchResults(results?.result);
            setHasSearched(true);
        } else if (!isLoadingSer && !errorMessageser) {
            setSearchResults([]);
            setHasSearched(true);
        }

        if (errorMessageser) {
            enqueueSnackbar('Failed to fetch search results.', { variant: 'error' });

        }
    }, [results?.result, isLoadingSer, errorMessageser]);



    useEffect(() => {
        // Reset the search state whenever the route changes
        setSearchQuery('');
        setSearchResults([]);
        setHasSearched(false);
    }, [location]);



    useEffect(() => {
        if (errorMessage && errorMessage !== 'You have not completed mandatory Tech Central Training, please complete it.') {
            Swal.fire({
                title: 'Error',
                text: errorMessage,
                icon: 'error',
                confirmButtonText: 'Retry',
                customClass: {
                    title: 'my-custom-title-of-pop-login',
                    confirmButton: 'my-custom-button-of-pop',
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
        }
    }, [errorMessage]);



    useEffect(() => {
        // Reset playing state when URL changes
        if (isVideoContent(selectedFile)) {
            setPlaying(false);
        }
    }, [selectedFile?.viewUrl]);



    const handleSearch = () => {
        if (!searchQuery.trim()) {
            enqueueSnackbar('Please enter a search term.', { variant: 'error' });
            return;
        }
        dispatch(contentSearch(searchQuery));
        setShowAll(false);
        setHasSearched(true);
    };



    const handleSearchInput = (e) => {
        const query = e.target.value;
        setSearchQuery(query);

        // Reset to default content if the search box is cleared
        if (query === '') {
            setSearchResults([]);
            setHasSearched(false);
        }
    };



    const handleKeywordClick = (keyword) => {
        setSearchQuery(keyword)
        dispatch(contentSearch(keyword));
        setShowAll(false);
        setHasSearched(true);
    };


    const handleShowFileModal = (file) => {
        let modifiedViewUrl = normalizeMediaUrl(file.viewUrl, 'preview');
        if (getMediaProvider(file.viewUrl) !== 'google-drive' && isVideoContent(file)) {
            // Change 'view' to 'preview' for mp4 files
            modifiedViewUrl = modifiedViewUrl.replace('/view', '/preview');
        } else if (getMediaProvider(file.viewUrl) !== 'google-drive' && file.contentType === 'Presentation') {
            // Append "&rm=minimal" to the viewUrl for pptx files
            modifiedViewUrl += '&rm=minimal';
        }
        setSelectedFile({ ...file, viewUrl: modifiedViewUrl });
        setFileModal(true);
    };

    const handleCloseFileModal = () => {
        setSelectedFile(null);
        setFileModal(false);
        setWaitingMessage('')
        setDownloading(false)
    };

    const Presentation = "Presentation";
    const Videos = "Video"
    const Shorts = "Shorts"
    const Playbook = "Playbook"
    const RelNotes = "Release Note"


    // Filter files based on file type and get the first four elements
    const pptFiles = content.filter(file => file.contentType === 'Presentation').slice(0, 4);
    const relaseNotes = content.filter(file => file.contentType === 'Release Note').slice(0, 4);
    const videoFiles = content.filter(file => file.contentType === 'Video').slice(0, 4);
    const playbookFiles = content.filter(file => file.contentType === 'Playbook').slice(0, 4);
    const shortsFiles = content.filter(file => file.contentType === 'Shorts').slice(0, 4);


    const getVideoDownloadFileName = (file) => {
        const fileName = file.fileName || file.title || file.name || 'video';

        return /\.[a-z0-9]+$/i.test(fileName) ? fileName : `${fileName}.mp4`;
    };

    const downloadVideo = async (videoUrl, file) => {
        setDownloading(true);

        try {
            const response = await fetch(videoUrl, { mode: 'cors' });

            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }

            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = getVideoDownloadFileName(file);

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Failed to download video as blob. Falling back to opening the URL.', error);
            window.open(videoUrl, '_blank', 'noopener,noreferrer');
        } finally {
            setDownloading(false);
        }
    };

    const downloadFile = (file) => {
        let downloadUrl;

        // Check if the file is a video
        if (isVideoContent(file)) {
            const videoDownloadUrl = file.downloadUrl || file.viewUrl;
            const normalizedVideoDownloadUrl = normalizeMediaUrl(videoDownloadUrl, 'download');

            if (getMediaProvider(videoDownloadUrl) === 'google-drive') {
                window.open(normalizedVideoDownloadUrl, '_blank', 'noopener,noreferrer');
                return;
            }

            downloadVideo(normalizedVideoDownloadUrl, file);
            return;
        }

        // Set loading state
        setDownloading(true);

        downloadUrl = normalizeMediaUrl(file.downloadUrl, 'download');

        // Create a temporary anchor element to initiate the download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `${file.fileName}.${file.fileExtension}`;

        // Append the anchor to the document body and trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up by removing the anchor from the document body
        document.body.removeChild(link);

        // Clear loading state after initiating the download
        setDownloading(false);
    };





    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                enqueueSnackbar('Password copied to clipboard!', { variant: 'success' });
            })
            .catch(() => {
                enqueueSnackbar('Failed to copy Password.', { variant: 'error' });
            });
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000, // Adjust as needed
        slidesToShow: 2, // Show two cards at a time
        slidesToScroll: 1
    };


    const handleContextMenu = (event) => {
        event.preventDefault(); // Prevents the context menu from appearing
    };
    const handleShowAll = () => {
        setShowAll(true);
        setSearchQuery('');
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch(e); // Pass the event object here
        }
    };

    const resultsNew = showAll ? content : searchResults;

    return (
        <>{isLoading && <LoadingScreen text="Loading..." />}
            <Navbar activeTab={"CONTENT_HUB"} activeTabSales={"CONTENT_STORE"} />

            {/* Main Div */}
            <div className='content-store-main-background'>

                {/* Top Header Section */}
                <div className='content-store-top-header-section'>
                    <div class="header-content">
                        <h1 className='content-store-head-h1'>Discover & Download Effortlessly from Our<br></br>Content Store!</h1>
                    </div>
                    <div class="search-form-content">
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            // onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={handleKeyDown}
                            onChange={handleSearchInput}
                        />
                        <button type="submit" onClick={handleSearch}>
                            <i class="fa-solid fa-arrow-right"></i>
                        </button>
                    </div>
                    <div class="suggested-keywords">
                        <ul>
                            {keywords.map((keyword, index) => (
                                <li key={index} onClick={() => handleKeywordClick(keyword)}>
                                    {keyword}
                                </li>
                            ))}
                        </ul>
                    </div>

                </div>


                <br></br>



                {/* Result */}
                <div className='result-section'>
                    <div className='container'>

                        {isLoadingSer ? (
                            <LoadingSpinner />
                        ) : errorMessageser ? (
                            <p>Error: {errorMessageser}</p>
                        ) : hasSearched ? (
                            resultsNew.length > 0 ? (
                                <>
                                    <p className='search-result-query'>
                                        {resultsNew.length} results for “{searchQuery}”
                                    </p>
                                    {/* <button className="close-button-black" onClick={() => setShowSearchResultsModal(false)}><span aria-hidden="true">&times;</span></button> */}
                                    <div className="row">
                                        {resultsNew.map(file => (
                                            <div className="col-sm-3" key={file.id}>
                                                {file.contentType === 'Presentation' && (
                                                    <div className="bg-primary-ppt" style={{ backgroundImage: `linear-gradient(to bottom, transparent, #052140), url(${normalizeMediaUrl(file.thumbnail, 'background')})` }} onClick={() => handleShowFileModal(file)}>{file.fileName}</div>
                                                )}
                                                {file.contentType === 'Video' && (
                                                    <div className="bg-primary-video" style={{ backgroundImage: `linear-gradient(to bottom, transparent, #052140), url(${normalizeMediaUrl(file.thumbnail, 'background')})` }} onClick={() => handleShowFileModal(file)}>{file.fileName}</div>
                                                )}
                                                 {file.contentType === 'Shorts' && (
                                                    <div className="bg-primary-video" style={{ backgroundImage: `linear-gradient(to bottom, transparent, #052140), url(${normalizeMediaUrl(file.thumbnail, 'background')})` }} onClick={() => handleShowFileModal(file)}>{file.fileName}</div>
                                                )}
                                                {file.contentType === 'Playbook' && (
                                                    <div className="bg-primary-playbook" style={{ backgroundImage: `linear-gradient(to bottom, transparent, #052140), url(${normalizeMediaUrl(file.thumbnail, 'background')})` }} onClick={() => handleShowFileModal(file)}>{file.fileName}</div>
                                                )}

                                                {file.contentType === 'Release Note' && (
                                                    <div
                                                        className="bg-primary-release"
                                                        style={getContentStoreCardBackgroundStyle(file.thumbnail)}
                                                        onClick={() => handleShowFileModal(file)}
                                                    >
                                                        <div className="file-info">
                                                            <p className='relase-notes-title'>{file.fileName}</p>
                                                        </div>
                                                    </div>
                                                )}

                                            </div>
                                        ))}
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                </>
                            ) : (
                                <div className='no-results'>No content available</div>
                            )
                        ) : (
                            <>
                                {relaseNotes.length > 0 && (
                                    <>
                                        <div className='result-sec-flex'>
                                            <div>
                                                <h6>Release Notes</h6>
                                                <div class="line"></div>
                                            </div>
                                            <div>
                                                <Link to={`${PATH.CONTENT_STORE_FILEFORMAT_PATH}${RelNotes}`} style={{ textDecoration: 'none' }}>
                                                    <h6 className='see-more-content-store'>See More</h6>
                                                </Link>
                                                <div class="line"></div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="row">
                                                {relaseNotes.map(file => (
                                                    <div className="col-sm-3" key={getReleaseNoteKey(file)}>
                                                        <div
                                                            className="bg-primary-release"
                                                            style={getContentStoreCardBackgroundStyle(file.thumbnail)}
                                                            onClick={() => handleShowFileModal(file)}
                                                        >
                                                            <div className="file-info">
                                                                <p className='relase-notes-title'>{file.fileName}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        <br></br>
                                        <br></br>
                                    </>
                                )}

                                {/* Presentation */}
                                <div className='result-sec-flex'>
                                    <div>
                                        <h6>Presentations</h6>
                                        <div class="line"></div>
                                    </div>
                                    <div>
                                        <Link to={`${PATH.CONTENT_STORE_FILEFORMAT_PATH}${Presentation}`} style={{ textDecoration: 'none' }}>
                                            <h6 className='see-more-content-store'>See More</h6>
                                        </Link>
                                        <div class="line"></div>
                                    </div>
                                </div>
                                <div>
                                    <div className="row">
                                        {pptFiles.map(file => (
                                            <div className="col-sm-3" key={file.releaseDate}>
                                                <div className="bg-primary-ppt" style={{ backgroundImage: `linear-gradient(to bottom, rgba(5, 33, 64, 0), rgba(0, 0, 0, 0.5)), url(${normalizeMediaUrl(file.thumbnail, 'background')})` }} onClick={() => handleShowFileModal(file)}>{file.fileName}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {/* -----XXXX */}

                                <br></br>
                                <br></br>

                                {/* Demo Shorts */}
                                <div className='result-sec-flex'>
                                    <div>
                                        <h6>Demo Shorts</h6>
                                        <div class="line"></div>
                                    </div>
                                    <div>
                                        <Link to={`${PATH.CONTENT_STORE_FILEFORMAT_PATH}${Shorts}`} style={{ textDecoration: 'none' }}>
                                            <h6 className='see-more-content-store'>See More</h6>
                                        </Link>
                                        <div class="line"></div>
                                    </div>
                                </div>
                                <div>
                                    <div className="row">
                                        {shortsFiles.map(file => (
                                            <div className="col-sm-3" key={file.releaseDate}>
                                                <div className="bg-primary-video" style={{ backgroundImage: `linear-gradient(to bottom, rgba(5, 33, 64, 0), rgba(0, 0, 0, 0.5)), url(${normalizeMediaUrl(file.thumbnail, 'background')})` }} onClick={() => handleShowFileModal(file)}>{file.fileName}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {/* ----XXXX--- */}

                                <br></br>
                                <br></br>

                                {/* Videos */}
                                <div className='result-sec-flex'>
                                    <div>
                                        <h6>Videos</h6>
                                        <div class="line"></div>
                                    </div>
                                    <div>
                                        <Link to={`${PATH.CONTENT_STORE_FILEFORMAT_PATH}${Videos}`} style={{ textDecoration: 'none' }}>
                                            <h6 className='see-more-content-store'>See More</h6>
                                        </Link>
                                        <div class="line"></div>
                                    </div>
                                </div>
                                <div>
                                    <div className="row">
                                        {videoFiles.map(file => (
                                            <div className="col-sm-3" key={file.releaseDate}>
                                                <div className="bg-primary-video" style={{ backgroundImage: `linear-gradient(to bottom, rgba(5, 33, 64, 0), rgba(0, 0, 0, 0.5)), url(${normalizeMediaUrl(file.thumbnail, 'background')})` }} onClick={() => handleShowFileModal(file)}>{file.fileName}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {/* ----XXXX--- */}

                                <br></br>
                                <br></br>


                                {/* Playbook */}
                                <div className='result-sec-flex'>
                                    <div>
                                        <h6>Playbooks</h6>
                                        <div class="line"></div>
                                    </div>
                                    <div>
                                        <Link to={`${PATH.CONTENT_STORE_FILEFORMAT_PATH}${Playbook}`} style={{ textDecoration: 'none' }}>
                                            <h6 className='see-more-content-store'>See More</h6>
                                        </Link>
                                        <div class="line"></div>
                                    </div>
                                </div>
                                <div>
                                    <div className="row">
                                        {playbookFiles.map(file => (
                                            <div className="col-sm-3" key={file.releaseDate}>
                                                <div className="bg-primary-playbook" style={{ backgroundImage: `linear-gradient(to bottom, rgba(5, 33, 64, 0), rgba(0, 0, 0, 0.5)), url(${normalizeMediaUrl(file.thumbnail, 'background')})` }} onClick={() => handleShowFileModal(file)}>{file.fileName}</div>
                                            </div>
                                        ))}
                                    </div>
                                    <br></br>
                                    <br></br>
                                </div>
                                {/* -----XXXX */}
                            </>
                        )}







                    </div>
                </div>
            </div>



            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                show={showFileModal} fullscreen={true} >
                <Modal.Body className='content-store-popup'>
                    <div className="container">
                        <div className='modal-div-learning'>
                            <div className="row">
                                <div className="col-sm-8 mb-3 mb-sm-0">
                                    {selectedFile && (
                                        <>
                                            {isVideoContent(selectedFile) && getMediaProvider(selectedFile.viewUrl) !== 'google-drive' ? (
                                                <div className="video-wrapper" onContextMenu={handleContextMenu}>
                                                    <div className="custom-react-player">
                                                        <ReactPlayer
                                                            url={selectedFile.viewUrl}
                                                            controls
                                                            playing={playing}
                                                            width="100%"
                                                            height="100%"
                                                            light={normalizeMediaUrl(selectedFile?.thumbnail, 'thumbnail')}
                                                            playIcon={
                                                                <button className="custom-play-button" onClick={handlePlayButtonClick}>
                                                                    ▶️
                                                                </button>
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="file-container">
                                                    <iframe
                                                        src={normalizeMediaUrl(selectedFile.viewUrl, 'preview')}
                                                        frameborder="0"
                                                        width="100%"
                                                        height="100%"
                                                        allowfullscreen="true"
                                                        title="File Preview"
                                                    ></iframe>
                                                </div>
                                            )}
                                            {isVideoContent(selectedFile) && (
                                                <p className="video-download-hint">Download is available from the video player controls.</p>
                                            )}
                                        </>
                                    )}

                                </div>
                                <div className="col-sm-4 mb-3 mb-sm-0">
                                    <div className="file-controls-dive">
                                        <h1 className='file-tite-des'>{selectedFile && selectedFile.fileName}</h1>
                                        <div class="line"></div>
                                        {/* <p className='file-p-des'>Publish Date : {selectedFile && selectedFile.releaseDate}</p> */}
                                        {/* <button class="card-cat-download" onClick={() => downloadFile(selectedFile)}disabled={downloading}>{downloading ? 'Downloading...' : 'Download'}</button> */}
                                        {/* <button
                                            className="card-cat-download"
                                            onClick={() => downloadFile(selectedFile)}
                                            disabled={downloading}
                                        >
                                            {downloading ? 'Downloading...' : 'Download PPT'}
                                        </button>
                                        <br></br>
                                        <br></br> */}
                                        {selectedFile && selectedFile.contentType == 'Playbook' && (
                                            <p className='file-p-des'>Password :
                                                <span
                                                    onClick={() => copyToClipboard('Playbook@123')}
                                                    style={{ cursor: 'pointer', }}
                                                    className='passowrd'
                                                >
                                                    Copy Password
                                                </span>
                                            </p>
                                        )}
                                        {selectedFile && !isVideoContent(selectedFile) && (
                                            <>
                                                <button
                                                    className="card-cat-download"
                                                    onClick={() => downloadFile(selectedFile)}
                                                    disabled={downloading}
                                                >
                                                    {downloading ? 'Downloading...' : 'Download'}
                                                </button>
                                                {waitingMessage && <p className='download-msg'>{waitingMessage}</p>}
                                                <br />
                                                <br />
                                            </>
                                        )}
                                        <button className='card-cat-cancel' onClick={handleCloseFileModal}>Back</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>








        </>
    )
}

export default Content_Store_v2
